module.exports = __webpack_public_path__ + "static/cloud-sharing-web-app-cover-10721821a39e28b295e481b642a2dc60.png";